import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import Switch from "@material-ui/core/Switch";
import { invokeApi } from "../../../../bl_libs/ApiCalling";
import { withRouter } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: "#c4314b",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  txt: {
    color: "black",
  },
  alert: {
    width: "100%",
  },
  swtch: {
    marginTop: "20px",
  },
}));

function Editextraitemform(props) {
  const classes = useStyles();
  const [id, setid] = useState();
  const [name, setname] = useState("");
  const [description, setdescription] = useState("");
  const [unit_price, setunit_price] = useState("");
  const [isactive, setisactive] = useState(false);
  const [currency, setcurrency] = useState("USD");
  const [iswaiting, setiswaiting] = useState(true);
  const [errorflag, setflag] = useState("");
  const handlesubmit = (event) => {
    event.preventDefault();
    setiswaiting(true);
    edititem();
  };
  const edititem = () => {
    let isActive = "";
    if (isactive) {
      isActive = "1";
    } else {
      isActive = "0";
    }
    let Data = {
      category_id: "",
      name: name,
      description: String(description),
      currency: currency,
      unit_price: String(unit_price),
      type: "2",
      size: "0",
      is_active: isActive,
    };
    console.log(Data, "dataaaaaaaa");
    const token = localStorage.getItem("token");
    let requestObj = {
      path: `/api/admin/edit_item/${props.match.params.id}`,
      method: "PUT",
      postData: Data,
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      //console.log(res, "RESPONSE");
      if (res.code == 200) {
        setiswaiting(false);
        props.history.push("/admin/extra-items");
      } else {
        setiswaiting(false);
        setflag(res.message);
      }
    });
  };
  const handleback = () => {
    props.history.push("/admin/extra-items");
  };
  const handlename = (event) => {
    setname(event.target.value);
  };
  const handledescription = (event) => {
    setdescription(event.target.value);
  };
  const handleunit_price = (event) => {
    setunit_price(event.target.value);
  };
  const handleisactivechanged = (event) => {
    if (isactive) {
      setisactive(false);
    } else {
      setisactive(true);
    }
  };

  const FetchExtraItemDetail = () => {
    const token = localStorage.getItem("token");
    let requestObj = {
      path: `/api/admin/detail_item/${props.match.params.id}`,
      method: "GET",
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      console.log(res, "RESPONSE");
      setid(res.items_Detail.id);
      setname(res.items_Detail.name);
      setdescription(res.items_Detail.desciption);
      setunit_price(res.items_Detail.unit_price);
      setisactive(res.items_Detail.is_active);
      setiswaiting(false);
    });
  };

  useEffect(() => {
    FetchExtraItemDetail();
  }, []);

  if (iswaiting) {
    return (
      <div className="Circular-Progress">
        <CircularProgress color="primary" />
      </div>
    );
  }
  return (
    <>
      <Container component="main" maxWidth="sm">
        <ArrowBackIcon
          className="backarrow pointer-point"
          color="primary"
          onClick={handleback}
        ></ArrowBackIcon>
        <CssBaseline />
        <div className={classes.paper}>
          <Typography className={classes.txt} component="h1" variant="h5">
            Edit extra item
          </Typography>
          {errorflag && (
            <Alert className={classes.alert} severity="error">
              {errorflag}
            </Alert>
          )}
          <form className={classes.form} onSubmit={handlesubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  value={name}
                  id="name"
                  onChange={handlename}
                  label="Name"
                  name="Name"
                  autoFocus
                />
              </Grid>
            </Grid>
            <TextField
              variant="outlined"
              margin="normal"
              value={description}
              fullWidth
              onChange={handledescription}
              name="description"
              label="Description"
              id="description"
            />
            <TextField
              variant="outlined"
              margin="normal"
              type="number"
              value={unit_price}
              fullWidth
              onChange={handleunit_price}
              name="unit_price"
              label="Unit Price"
              id="unit_price"
            />
            Status:
            <Switch
              checked={isactive}
              onChange={handleisactivechanged}
              color="primary"
              name="status"
              inputProps={{ "aria-label": "primary checkbox" }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Edit extra item
            </Button>
          </form>
        </div>
      </Container>
    </>
  );
}
export default withRouter(Editextraitemform);
